Ext.define('SA.MouseActivity', {
    constructor({xy, eventPrefix, eventTarget, clickParams, dragStartParams}) {
        this.xy = xy;

        this.eventPrefix = eventPrefix;
        this.eventTarget = eventTarget;

        this.neverMoved = true;
        this.didStartDrag = false;

        this.clickParams = clickParams;
        this.dragStartParams = dragStartParams;

        this.initEvents();
    },

    emitEvent(type, detail = {}) {
        type = this.eventPrefix + ':' + type;
        detail = Object.assign({xy: this.xy}, detail);

        return this.eventTarget.dispatchEvent(new CustomEvent(type, {bubbles: true, cancelable: true, detail}));
    },

    initEvents() {
        this.onMouseMove = this.onMouseMove.bind(this);

        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp.bind(this), {once: true});
    },

    onMouseMove({clientX: x, clientY: y}) {
        this.xy = [x, y];
        this.neverMoved = false;

        if (this.didStartDrag) {
            this.emitEvent('drag');
            return;
        }

        this.didStartDrag = this.emitEvent('dragstart', this.dragStartParams);

        if (!this.didStartDrag) {
            this.removeMouseMoveListener();
        }
    },

    onMouseUp() {
        this.removeMouseMoveListener();

        if (this.neverMoved) {
            this.emitEvent('click', this.clickParams);
        }
        else if (this.didStartDrag) {
            this.emitEvent('dragend');
        }
    },

    removeMouseMoveListener() {
        document.removeEventListener('mousemove', this.onMouseMove);
    }
});